"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderNotFoundException = void 0;
var OrderNotFoundException = /** @class */ (function () {
    function OrderNotFoundException() {
    }
    return OrderNotFoundException;
}());
exports.OrderNotFoundException = OrderNotFoundException;
